import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n/config';
import App from './App';

// Auth travels in an httpOnly cookie. In production the API lives on a
// different origin (dashboard.antitraffickingmap.online → antitraffickingmap.online),
// so every API request must opt into sending credentials. Wrap fetch once,
// scoped to /api URLs only, instead of editing every call site.
const nativeFetch = window.fetch.bind(window);
window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
  const url =
    typeof input === 'string'
      ? input
      : input instanceof URL
        ? input.toString()
        : input.url;
  const isApiRequest = /(^|\/)api(\/|$)/.test(url);
  if (isApiRequest && (!init || init.credentials === undefined)) {
    return nativeFetch(input, { ...(init || {}), credentials: 'include' });
  }
  return nativeFetch(input, init);
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .catch(() => {
        // Service worker registration is best-effort; ignore failures.
      });
  });

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}
